'use client';

import { Instance } from '@/editora/Instance';

export const Instances = ({ instances = [], ...props }) => {
  return instances.map((instance) => {
    return (
      <Instance
        key={instance?.meta?.id || instance?.meta?.key}
        instance={instance}
        {...props}
      />
    );
  });
};
